import React, { Component, FunctionComponent } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IOrder from "../../../models/IOrder";
import "./TaxJarTaxBreakdownModal.scss";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    closeModalFn: () => void;
    orderModel: IOrder;
};

const TaxJarTaxBreakdownModal: FunctionComponent<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    return (
        <div className={"TaxJarTaxBreakdownModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-search"} title={"taxjar_details"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <pre>{JSON.stringify(props.orderModel.taxjar_calc_tax_resp?.tax, null, 2)}</pre>
            </div>
        </div>
    );
};

export default TaxJarTaxBreakdownModal;
